export const NS_LIBS_DATETIME = "libs-datetime";

export enum K {
  TODAY = "TODAY",
  YESTERDAY = "YESTERDAY",
  FUTURE_AFTER = "FUTURE_AFTER",
  FORMAT_MEDIUM_DATETIME = "FORMAT_MEDIUM_DATETIME",
  FORMAT_MEDIUM_DATE = "FORMAT_MEDIUM_DATE",
  FORMAT_SHORT_DATETIME = "FORMAT_SHORT_DATETIME",
  FORMAT_SHORT_DATE = "FORMAT_SHORT_DATE",
  FORMAT_SHORT_DAY_DATETIME = "FORMAT_SHORT_DAY_DATETIME",
  FORMAT_SHORT_DAY_DATE = "FORMAT_SHORT_DAY_DATE",
  SECONDS = "SECONDS",
  MILL_SECONDS = "MILL_SECONDS",
  MINUTES = "MINUTES",
  HOURS = "HOURS",
  DAYS = "DARS",
  MONTHS = "MONTHS",
}

export type Locale = { [key in K]: string };
